export const isAnsweredEntry = (entry) =>
  Boolean(String(entry?.answeredBy || "").trim());

export const MIN_COLLAPSED_CALLS = 3;

export const isOwnedEntry = (entry, activeCallerId, agentName) => {
  if (entry?.id === activeCallerId) return true;
  const answeredBy = String(entry?.answeredBy || "").trim();
  const currentAgent = String(agentName || "").trim();
  return Boolean(answeredBy && currentAgent && answeredBy === currentAgent);
};

export const groupQueueEntries = (
    entries,
    activeCallerId,
    agentName,
    listeningCallerId = "",
) => {
  const grouped = [];
  let activeRun = [];
  let queueSlot = 0;

  const flushActiveRun = () => {
    if (!activeRun.length) return;
    grouped.push({
      type: "active-stack",
      id: `active-slot-${queueSlot}`,
      entries: activeRun,
    });
    activeRun = [];
  };

  (entries || []).forEach((entry) => {
    const isMonitored = Boolean(
        listeningCallerId && entry?.id === listeningCallerId,
    );
    if (isMonitored) {
      flushActiveRun();
      grouped.push({type: "monitored-call", id: entry.id, entry});
      queueSlot += 1;
      return;
    }
    const handledByAnotherAgent = isAnsweredEntry(entry) &&
      !isOwnedEntry(entry, activeCallerId, agentName);

    if (handledByAnotherAgent) {
      activeRun.push(entry);
      return;
    }

    flushActiveRun();
    grouped.push({type: "caller", id: entry.id, entry});
    queueSlot += 1;
  });

  flushActiveRun();
  return grouped;
};
